// ./src/components/features/Forms/FormFieldTypeBadge/FormFieldTypeBadge.tsx
import React, { useMemo } from "react";
import { Badge, Group } from "@mantine/core";
import { useFormFieldTypesContext } from "@/contexts";

export interface FormFieldTypeBadgeProps {
  /** Field type ID */
  type: number | null | undefined;

  /** Badge size */
  size?: "xs" | "sm" | "md" | "lg" | "xl";

  /** Badge variant */
  variant?: "filled" | "light" | "outline" | "dot" | "default";

  /** Badge color */
  color?: string;

  /** Whether to show icon */
  showIcon?: boolean;
}

export const FormFieldTypeBadge: React.FC<FormFieldTypeBadgeProps> = ({
  type,
  size = "sm",
  variant = "light",
  color = "blue",
}) => {
  const { formFieldTypes } = useFormFieldTypesContext();

  const fieldType = useMemo(() => {
    if (type == null) return null;
    return formFieldTypes.find((ft) => ft.id === type.toString());
  }, [type, formFieldTypes]);

  if (type == null) {
    return (
      <Badge size={size} variant={variant} color="gray">
        No Type
      </Badge>
    );
  }

  if (!fieldType) {
    return (
      <Badge size={size} variant={variant} color="gray">
        Type {type}
      </Badge>
    );
  }

  return (
    <Badge size={size} variant={variant} color={color}>
      <Group gap={4} wrap="nowrap">
        {/* {showIcon && fieldType.icon && (
          <AppIcon iconName={fieldType.icon} size={12} />
        )} */}
        {fieldType.name}
      </Group>
    </Badge>
  );
};
